import React, { useState } from "react";
import Fetch from "../fetch/auth";
import { MasterKey } from "../../config";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Mail from "@material-ui/icons/Mail";
import CircularProgress from "@material-ui/core/CircularProgress";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import NewSnack from "../Snackbar/newSnack";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles({
  TextFieldRtl: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(135px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(167px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right",
        width: "85px"
      }
    }
  },
  TextFieldRtlResp: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(90px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(119px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right",
        width: "85px"
      }
    }
  },
  TextFieldPassRtl: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(190px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(205px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right"
      }
    }
  },
  TextFieldPassRtlResp: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(144px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(159px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right"
      }
    }
  },
  TextFieldRtlname: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(125px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(155px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right"
      }
    }
  },
  TextFieldRtlnameResp: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(77px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(110px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right"
      }
    }
  }
});
export default function RegisterForm(props) {
  const [loading, setLoading] = useState(false);
  const size = useMediaQuery("(max-width:960px)");
  const [pass, setPass] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    type: "error",
    message: "sample"
  });

  const classes = useStyles();
  const { lang, multiLang, dir } = props;
  async function handelSubmit(e) {
    e.preventDefault();
    setLoading(true);
    let data = {
      query: `
        mutation {
        registerUser(
            name: "${e.target.name.value}"
            email: "${e.target.email.value}"
            password: "${e.target.password.value}"
        ) {
            token
            user {
                name
            }
        }
    }
    `
    };

    const auth = "Bearer " + MasterKey;
    try {
      const response = await Fetch({ auth, body: JSON.stringify(data) });
      // console.log(response);
      setSnack({
        open: true,
        type: "success",
        message: multiLang["A017"][lang]
      });
      props.setUser(response.registerUser);
    } catch (err) {
      console.log(err);
      setSnack({
        open: true,
        type: "error",
        message: multiLang["A016"][lang]
      });
    }
    setLoading(false);
  }
  console.log("register snack", snack);
  async function handleClose() {
    await setSnack({
      open: false,
      type: "error",
      message: ""
    });
  }
  return (
    <div>
      <NewSnack snack={snack} handleClose={handleClose} />
      {/* <NewSnack
        snack={{ open: true, type: "success", message: "test message" }}
      /> */}
      <Grid container spacing={3}>
        <form
          onSubmit={handelSubmit}
          autoComplete="true"
          style={{ margin: "0 auto" }}
        >
          <Grid item xs={12} style={{ margin: "20px auto" }}>
            <TextField
              name="name"
              className={`${classes.TextField} ${dir === "rtl" && (size ? classes.TextFieldRtlnameResp : classes.TextFieldRtlname)}`}
              variant="outlined"
              label={multiLang["025"][lang]}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end">
                      <AssignmentInd />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={12} style={{ margin: "20px auto" }}>
            <TextField
              name="email"
              className={`${classes.TextField} ${dir === "rtl" && (size ? classes.TextFieldRtlResp : classes.TextFieldRtl)}`}
              variant="outlined"
              type="email"
              label={multiLang["023"][lang]}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton disabled edge="end">
                      <Mail />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={12} style={{ margin: "20px auto" }}>
            <TextField
              name="password"
              className={`${classes.TextField} ${dir === "rtl" && (size ? classes.TextFieldPassRtlResp : classes.TextFieldPassRtl)}`}
              variant="outlined"
              type={pass ? "text" : "password"}
              label={multiLang["024"][lang]}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      aria-label="Toggle password visibility"
                      onClick={() => setPass(!pass)}
                    >
                      {pass ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={12} style={{ margin: "20px auto" }}>
            <Button
              variant="contained"
              className={classes.Singin}
              color="primary"
              disabled={loading}
              type="submit"
            >
              {loading ? (
                <>
                  <span>{multiLang["026"][lang]}</span>
                  <CircularProgress size={20} thickness={5} />
                </>
              ) : (
                multiLang["022"][lang]
              )}
            </Button>
          </Grid>
        </form>
      </Grid>
    </div>
  );
}
